export const COLORS: Record<string, string> = {
  reset: "\u001b[0m",
  dim: "\u001b[2m",
  bold: "\u001b[1m",
  red: "\u001b[31m",
  green: "\u001b[32m",
  yellow: "\u001b[33m",
  blue: "\u001b[34m",
  magenta: "\u001b[35m",
};

export const STATUS_COLORS: Record<string, string> = {
  running: "blue",
  provisioning: "blue",
  queued: "dim",
  created: "dim",
  delivering: "blue",
  verifying: "blue",
  waiting_human: "yellow",
  waiting_external: "blue",
  awaiting_approval: "yellow",
  completed: "green",
  failed: "red",
  killed: "red",
  abstained: "yellow",
};
